import { createFileRoute } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import { graphql } from "@repo/graphql-types";
import { PendingComponent } from "@/components/ui/loading/pending-component";
import {
  HeaderRoot,
  HeaderTitle,
  HeaderUpButton,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { AppointmentInfosForm } from "@/components/assist/secretary-details/appointment-infos-form";
import { useSuspenseGraphQL } from "@/hooks/use-graphql.ts";

// biome-ignore lint/plugin/route-file-exports: predates the rule; move it out
export const GetSecretaryAppointmentInfosQuery = graphql(/* GraphQL */ `
  query GetSecretaryAppointmentInfosQuery {
    ...AppointmentInfosFormFragment
  }
`);

const AppointmentInfosPage = (): React.ReactNode => {
  const { data } = useSuspenseGraphQL(GetSecretaryAppointmentInfosQuery, {});
  return (
    <>
      <HeaderRoot>
        <HeaderUpButton icon={Left} align="start" />
        <HeaderTitle title="" align="center" />
      </HeaderRoot>
      <Page>
        <AppointmentInfosForm data={data} />
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/assist/secretary-details/appointment-infos",
)({
  component: AppointmentInfosPage,
  pendingComponent: () => <PendingComponent title="Informações de atendimento" />,
});
